import React from "react";
import {
  FeatureGate,
  FEATURE_GATES,
} from "../../feature-gates/FeatureGateContext";
import LiveAnalogPage from "./live-analog-page";
import LiveSeriesPage from "./live-series-page";

function LivePage() {
  return (
    <FeatureGate
      feature={FEATURE_GATES.LIVE_ANALOG_PAGE}
      fallback={
        <FeatureGate
          feature={FEATURE_GATES.LIVE_SERIES_PAGE}
          fallback={
            <div className="live-course-empty">该功能暂未开放，请稍后再试</div>
          }
        >
          <LiveSeriesPage />
        </FeatureGate>
      }
    >
      <LiveAnalogPage />
    </FeatureGate>
  );
}

export default LivePage;
